import { render, staticRenderFns } from "./PopupAgeVerify.vue?vue&type=template&id=659aabb3&scoped=true"
import script from "./PopupAgeVerify.vue?vue&type=script&lang=js"
export * from "./PopupAgeVerify.vue?vue&type=script&lang=js"
import style0 from "./PopupAgeVerify.vue?vue&type=style&index=0&id=659aabb3&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "659aabb3",
  null
  
)

export default component.exports